import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/onboarding")({
  component: () => <Outlet />,
});
